import React from 'react';
import {
	getGridSingleSelectOperators,
	GridColDef,
	GridRenderCellParams,
	GridRowParams,
} from '@innovyze/stylovyze';
import { TFunc } from '@Translations/types';
import { Link } from '@mui/material';
import { SelectProps } from '@innovyze/lib-am-common';
import { MenuCell } from './MenuCell';

export const tableColumns = (
	t: TFunc,
	filters: SelectProps[],
	handleOpen: (assetId: string) => void,
	isFindAssetsEnabled: boolean,
	onFindAsset: (assetId: string) => void,
	groupCells: string[][],
): GridColDef[] => [
	{
		field: 'ASSET_ID',
		headerName: t('Asset ID'),
		renderCell: (params: GridRenderCellParams) => (
			<Link
				style={{
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					cursor: 'pointer',
				}}
				title={params.value}
				onClick={() => {
					handleOpen(params.value as string);
				}}>
				{params.value}
			</Link>
		),
		flex: 1,
		filterable: false,
		width: 100,
		pinnable: false,
	},
	{
		field: 'FINAL_RRHAB_ACTION',
		headerName: t('Group'),
		align: 'left',
		headerAlign: 'left',
		type: 'singleSelect',
		filterOperators: getGridSingleSelectOperators().filter(
			operator => operator.value === 'isAnyOf',
		),
		valueOptions: groupCells?.map(cells => ({
			value: cells[6],
			label: cells[0],
		})),
		filterable: true,
		flex: 1,
		sortable: false,
		pinnable: false,
		renderCell: (params: GridRenderCellParams) => params.value,
	},
	{
		field: 'NOTES',
		headerName: t('Description'),
		filterable: false,
		sortable: true,
		flex: 1,
		pinnable: false,
	},
	{
		field: 'menu',
		headerName: '',
		sortable: false,
		filterable: false,
		hideable: false,
		maxWidth: 50,
		minWidth: 50,
		width: 50,
		align: 'center',
		disableColumnMenu: true,
		type: 'actions',
		getActions: (params: GridRowParams) => {
			return MenuCell(params, isFindAssetsEnabled, onFindAsset);
		},
	},
];
